import React from "react";
import { createPortal } from "react-dom";
import { Clipboard, Share2, X } from "lucide-react";

export default function CounselingSharingModal({ sharingStudent, onClose, theme, openAlert }) {
  if (!sharingStudent) return null;

  const shareText = `[학생 정보]\n이름: ${sharingStudent.name}\n연락처: ${sharingStudent.phone}\n부서: ${sharingStudent.grade}\n\n[특이사항]\n${sharingStudent.notes || "없음"}`;

  return createPortal(
    <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center z-[9995] p-4" onClick={onClose}>
      <div className="bg-white rounded-[2rem] p-8 w-full max-w-sm shadow-2xl relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 bg-gray-100 p-2 rounded-full">
          <X size={20} />
        </button>
        <h3 className={`text-2xl font-black ${theme.text} mb-6 font-do-hyeon flex items-center gap-2`}>
          <Share2 size={24} /> 학생 정보 공유
        </h3>
        <div className="bg-gray-50 p-5 rounded-2xl text-sm text-gray-600 mb-6 whitespace-pre-wrap border border-gray-200 leading-relaxed shadow-inner">
          {shareText}
        </div>
        <button
          onClick={() => {
            navigator.clipboard.writeText(shareText);
            openAlert("복사되었습니다!", "알림");
            onClose();
          }}
          className={`w-full py-4 ${theme.bg} text-white rounded-2xl font-bold hover:opacity-90 transition shadow-lg flex items-center justify-center gap-2`}
        >
          <Clipboard size={20} /> 텍스트 복사
        </button>
      </div>
    </div>,
    document.body
  );
}
